import isIPad from '../util/isIPad';

export default function header() {
  const $ = jQuery;
  const windowWidth = $(window).width();

  $('.mobile-nav').on('click', function() {
    $('.mobile-nav').removeClass('active');
    $(this).addClass('active');

    const selected = $(this).data('link');

    $('.nav-triangle-line').removeClass(
      'home technology industry company blog excellence'
    );
    $('.nav-triangle-line').addClass(selected);

    if (selected === 'industry') {
      $('.nav-item').removeClass('hide');
    } else {
      $('.nav-item').addClass('hide');
    }
  });

  $('#nav-open').on('click', function() {
    $('.mobile-menu').addClass('open');
    $('html').addClass('menu-open');
  });

  $('#nav-close').on('click', function() {
    $('.mobile-menu').removeClass('open');
    $('html').removeClass('menu-open');
  });

  $('.nav-primary-mobile .menu-item').on('click', function() {
    $('.nav-primary-mobile .menu-item').removeClass('hover');
    $(this).addClass('hover');
    $('.nav-triangle-line').css('top', $(this).position().top - 8 + 'px');
  });

  window.onresize = function() {
    if (isIPad() && $(window).width() != windowWidth) {
      window.location.reload();
    }
  };

  $('*')
    .on('touchstart', function() {
      $(this).trigger('hover');
    })
    .on('touchend', function() {
      $(this).trigger('hover');
    });

  const $navMobileCurrentItem = $(
    '.nav-primary-mobile .menu-item.current-menu-item'
  );

  if ($navMobileCurrentItem.length) {
    setTimeout(() => {
      $('.nav-triangle-line').css(
        'top',
        $navMobileCurrentItem.position().top - 8 + 'px'
      );
      $navMobileCurrentItem.addClass('hover');
    }, 100);
  }

  // Fix menu underline
  var current_item = $(
    '.nav-primary .mega-current-menu-parent.pink>.mega-menu-link'
  ).text();

  if (current_item) {
    $('#mega-menu-primary_navigation>.mega-current-menu-ancestor').removeClass(
      'mega-current-menu-ancestor'
    );
    $('#mega-menu-primary_navigation>.mega-menu-item').each(function() {
      if ($(this).find('>.mega-menu-link').text() == current_item) {
        $(this).addClass('mega-current-menu-ancestor-custom');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/layout/header.js